<div class="panel etat-panel">
  <app-spinner-overlay [visible]="chargement()" label="Chargement de l'état..." />

  @if (chargement()) {
    <p class="panel-message">Chargement...</p>
  } @else if (erreurChargement()) {
    <p class="panel-message panel-message-error">{{ erreurChargement() }}</p>
  } @else if (installation(); as installation) {
    <h2>État de l'installation</h2>
    <h3 class="section-label">Statut</h3>

    <div class="statut-card">
      <app-installation-statut-panel
        [statusText]="statusLabel(installation.etat)"
        [statusColor]="installation.etat?.couleur || '#6f746f'"
        [statusClass]="installation.etat ? statusClass(installation.etat) : 'neutral'"
        [derniereMiseAJour]="chiffresUtiles()?.derniere_mesure ?? null"
      />

      <div class="statut-meta">
        @for (metric of quickMetrics(); track metric.icon) {
          <span class="metric-chip" [title]="metric.tooltip ?? metric.title">
            <span class="material-symbols-outlined" aria-hidden="true">{{ metric.icon }}</span>
            <span class="visually-hidden">{{ metric.title }} : </span>
            {{ metric.value }}
          </span>
        }
        @for (tag of tagsAffiches(); track tag.id) {
          <span class="tag-chip" [style.--tag-color]="tag.couleur">
            {{ tag.libelle }}
          </span>
        }
      </div>

      @if (afficherDeie()) {
        <app-installation-deie-panel [date]="deieDate()" [items]="deieItems()" />
      }
    </div>

    <app-installation-equipements-panel [installation]="installation" [defautsPrecharges]="defautsPrecharges()" affichage="groupes" />

    <app-installation-ticket-panel [installationId]="installation.id" />
  } @else {
    <p class="panel-message">Chargement...</p>
  }
</div>
